// Components==============
import { useContext, useEffect } from 'react';
import { TranslateType } from 'typings';
import { GlobalConfirmContext } from 'utilities/GlobalContext/GlobalConfirm';
import useFunctionAsState from './useFunctionAsState';
// =========================

export function useConfirm() {
  const {
    setConfirm,
    confirmState,
    setConfirmState,
    triggerClearConfirmFunction,
  } = useContext(GlobalConfirmContext);

  const [confirmFunction, setConfirmFunction] = useFunctionAsState(undefined);

  useEffect(() => {
    if (!confirmFunction) return;
    if (confirmState === 'confirmed') {
      confirmFunction();
      setConfirmFunction(undefined);
    }
  }, [confirmState]);

  useEffect(() => {
    setConfirmFunction(undefined);
  }, [triggerClearConfirmFunction]);

  return (message: TranslateType, fn: any) => {
    setConfirmState('asking');
    setConfirm(message);
    setConfirmFunction(fn);
  };
}
